import React from "react";
import { Helmet } from "react-helmet";

export default function ReactHelmet({ title, description, faqSchema, canonical }) {
  const canonicalLink = window.location.href ? window.location.href : "https://tasterecovery.com";
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link
        rel="canonical"
        href={canonical ? canonical : canonicalLink}
      />
      <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
      <link rel="icon" href="/public/icon-176.png" />
    </Helmet>
  );
}
